//好评送延保
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :type="editViewType" :_dataId.sync="dataId"
          :parent-target="_self" @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid show-overflow :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="slProductExport" status="primary" class="button-sty" icon="el-icon-top"
                    @click="exportExcel()">导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                    @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form ref="form" class="screen-box" title-width="5vw" title-align="right" :data="formData"
                @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="申请单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.applyNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="状态:" field="stat">
                    <template v-slot>
                      <el-select v-model="formData.stat" clearable style="width:9vw!important ;">
                        <el-option :value="1" label="待审核"></el-option>
                        <el-option :value="2" label="已审核"></el-option>
                        <el-option :value="3" label="审核不通过"></el-option>
                        <el-option :value="4" label="做废"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="SN号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.barcode" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item :title="$t('common.CreationTime')+':'" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="formData.createDate" type="daterange" align="right"
                                      unlink-panels range-separator="-"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>

                      <span>

                      <i class="el-icon-sort-down icon_w" :style=" icon_T ? 'color:#00c4b3': ''"
                         @click="creationTimeSortEvent(2)"></i>
                      <i class="el-icon-sort-up" :style=" icon_T ? '': 'color:#00c4b3'"
                         @click="creationTimeSortEvent(1)"></i>
                    </span>
                    </template>
                  </vxe-form-item>

                </vxe-form>
              </el-collapse-transition>
              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
                    btnGoodsStatusBt1: goodsStatusIndex == index,
                    btnGoodsStatusBt: goodsStatusIndex != index
                  }" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color" v-if="item.name !== '所有'">{{ item.num }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
            <template #option="{ row }">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id, 'info')">
                <el-tooltip effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                  <i class="el-icon-edit" />
                </el-tooltip>
              </a>
              <el-dropdown @command="handleCommand($event, row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a" v-if="row.stat == 1&&checkButton">审核</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <commentRemark v-if="showCommentRemarkDialog" @followUpCommentRemark="followUpCommentRemark" :visiable.sync="showCommentRemarkDialog"
                 :params="commentRemarkParams"/>
  </div>
</template>

<script>
import editView from './edit.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
//审核
import commentRemark from "./commentRemarkDialog";
export default {
  name: 'product',

  inject: ['reload'],
  components: { editView, pager,
    // 审核
    commentRemark,},
  data() {
    return {
      icon_T: true,
      goodsStatusList: [],
      showCommentRemarkDialog:false,

      total: 0,
      editViewType: null,
      brandOptions: [],
      orderTypeOptions: [],
      serviceTypeOption: [],
      dispatchStatOptions: [],
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        applyNo: "",
        stat: 1,
        creationTimeSort: 2,
        createTimeBegin: null,
        createTimeEnd: null,
        barcode:null
      },

      formData: {
        applyNo: "",
        stat: 1,
        creationTimeSort: 2,
        createDate:"",
        createTimeBegin: null,
        createTimeEnd: null,
        barcode:''
      },

      commentRemarkParams: {
        dataId: 0,
        applyNo: "",
      },

      sitePromptList: [],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',

      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,
      activeName: 'second',
      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        { type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left' },
        { width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' } },
        {
          title: '申请单号', field: 'applyNo', width: 180,
        },
        {
          title: '状态', field: 'stat', width: 150, slots: {
            default: ({ row }) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status neutral">
                    <span>待审核</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status">
                    <span>已审核</span>
                  </div>
                ];
              }else if (row.stat == 3) {
                return [
                  <div class="txt-status disable">
                    <span>审核不通过</span>
                  </div>
                ];
              }else if (row.stat == 4) {
                return [
                  <div class="txt-status disable">
                    <span>做废</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '用户昵称', field: 'nickName', width: 100, },
        { title: '微信ID', field: 'wxId', width: 150, },
        { title: 'SN号', field: 'barcode', width: 150, },
        { title: '用户名', field: 'custName', width: 150, },
        { title: '用户档案号', field: 'profileNo', width: 100, },
        { title: '赠送延保(月)', field: 'goodCommentGift', width: 100, },
        { title: '创建时间', field: 'createTime', width: 150, },
        { title: '创建人', field: 'createBy', width: 80, },
      ]
    };
  },

  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    // activeName(newVal) {
    //   if (newVal === 'second' && this.editViewDataUpdateFlag) {
    //     this.getTableData()
    //   }
    // },
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.exportButton = this.permissions["wkGoodCommentApplyExport"];
    this.checkButton = this.permissions["wkGoodCommentApplyCheck"]; //审核
    console.log("审核权限:",checkButton)

  },

  mounted() {
    this.loadTabOption()

    this.initSearchDate()
    this.getTableData()
  },

  methods: {
    toFilterData() {
            this.searchEvent();
     },
        // 加载tab数据
    loadTabOption() {
      this.$http({
        url: api.wkGoodCommentApply.getCountUrl,
        method: 'get',
        params: this.requestParam
      }).then(res => {
        console.log("tab数据",res.data.data)
        this.goodsStatusList = res.data.data
        this.goodsStatusList.forEach((item,index) =>{
          if(item.num === null){
            item.num = 0
          }
        })
      })
    },
    // tab也切换为列表页
    goBackIndex() {
      this.activeName = 'second'
      this.showEdit = false
      this.flushed()
    },

    flushed() {
      this.loadTabOption()

      this.$refs['table-m1'].commitProxy('reload');
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
      start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createDate = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: { userName: queryStr }
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({ value: item.userName, id: item.id })
        })
        callback(temp)
      })
    },
    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
      let s = null
      if (item.name === '待审核') {
        s = 1
      } else if (item.name === '审核不通过') {
        s = 3
      }
      this.requestParam.stat = s
      this.formData.stat = s
      this.flushed()
    },

    //创建时间排序
    creationTimeSortEvent(val) {
      this.icon_T = !this.icon_T
      console.log('创建时间排序事件:', val)
      if (val == 1) {
        this.icon_T = false
      } else if (val == 2) {
        this.icon_T = true

      }
      this.formData.creationTimeSort = val;
      this.searchEvent();
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.wkGoodCommentApply.getTableDataUrl,
        param: this.requestParam,
        method: 'get',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 操作
    handleCommand(command, row) {
      console.log(command, row, "command,a的值");
      if (command === 'a') {
        this.showCommentRemarkDialog = true;
        this.commentRemarkParams.dataId = row.id;
        this.commentRemarkParams.applyNo = row.applyNo;
      } else if (command === '') {

      }
    },
    followUpCommentRemark(type){
      console.log(type,'yyyy')
      this.showCommentRemarkDialog = type
      if(type==false){
        this.reload()// 需要刷新页面
      }
    },
    // 新增/修改
    openEditDialog(id, type) {
      this.editViewType = type
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },




    // 选中的按钮

    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },



    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },




  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

// ::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
//   display: inline-block;
//   width: 20%;
// }

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}
// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBtn {
  //白底按钮

  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}
</style>
